import React from 'react';
import Spinner from '@atlaskit/spinner';
import styled from '@emotion/styled';

export function FirstImpressionsLoadingView() {
  return (
    <FirstImpressionsLoadingViewContainer>
      <SpinnerWrapper>
        <Spinner size="large" />
      </SpinnerWrapper>
    </FirstImpressionsLoadingViewContainer>
  );
}

const FirstImpressionsLoadingViewContainer = styled.div`
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
`;

const SpinnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 400px;
  max-width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
